import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/services/auth/auth.service';

@Component({
  selector: "app-welcome-dashboard",
  templateUrl: "./welcome-dashboard.component.html",
  styleUrls: ["./welcome-dashboard.component.css"],
})
export class WelcomeDashboardComponent implements OnInit {
  title = "Data Enrichment and Governance";
  showData2U = false;
  showEMTS = false;

  constructor(private router: Router, private authService:AuthService) {}

  ngOnInit() {
    const userRaw = localStorage.getItem('user');
  if (userRaw) {
    const user = JSON.parse(userRaw);
    const userRole = (user.role || '').toLowerCase();
    if (userRole === 'admin') {
        this.showData2U = true;
        this.showEMTS = true;
      } else {
        const access = (user.hasAccess || []).map((x: string) => x.toLowerCase());

        this.showData2U = access.includes('data2u');
        this.showEMTS = access.includes('emts');
      }
  }
  }
  goToDisclaimer() {
    this.router.navigate(["/disclaimer"]);
  }
  
  private openExternalAppWithHandshake(baseUrl: string): void {
    const userData = JSON.parse(localStorage.getItem('user')); 
    if (!userData) return;

    const { email, userId, role } = userData;
    const id = userId || userData._id; // Ensure we have the ID

    // 1. Generate the fresh code exactly when called
    const freshCode = Math.floor(100000 + Math.random() * 900000);

    // 2. Save to DB first
    this.authService.saveHandshake(id, freshCode).subscribe(
        (res) => {
            // SUCCESS: Build the URL with the verifyCode
            const params = new URLSearchParams();
            params.set('userId', id);
            params.set('verifyCode', freshCode.toString());
            
            if (email) params.set('email', email);
            if (role) params.set('role', role);

            const fullUrl = `${baseUrl}?${params.toString()}`;

            // 3. Open the tab now that the DB is ready
            window.open(fullUrl, "_blank");
        },
        (err) => {
            console.error("Handshake save failed", err);
            // Fallback: open without code if server is down
            window.open(baseUrl, "_blank");
        }
    );
}

  openEtim(): void {
    this.openExternalAppWithHandshake("http://etimext.azurewebsites.net/");
}

  openVolumeValidator(): void {
      this.openExternalAppWithHandshake("https://volumevalidation-esbpfbdfgtf5gsar.malaysiawest-01.azurewebsites.net/");
 
  }
}
